import { BKJTableBody, BKJTableWrapper } from 'components/BKJTable/BKJTable.styled';
import { BKJTableRowWrapper } from 'components/BKJTable/BKJTableRow/BKJTableRow.styled';
import styled from 'styled-components';
import { BKJForm } from 'components/FormWrapper';
import { P } from 'components/Typography';
import { BKJButton } from '@bookjane2/bookjane-design-library';
import { BKJTableSubHeaderWrapper } from 'components/BKJTable/BKJTableSubHeader/BKJTableSubHeader.styled';

export const PositionsAllocationForm = styled(BKJForm)`
  max-height: 100%;
`;

export const PositionsAllocationNote = styled(P)`
  margin-bottom: 0;
`;

export const NoAssignedPositionsMessageTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
`;

export const EmptyStateMessage = styled.div`
  font-size: 20px;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const NoAssignedPositionsMessage = styled.div`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const PositionsAllocationEditButton = styled(BKJButton)`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  min-height: 44px;
`;

export const PositionsAllocationSubHeaderWrapper = styled(BKJTableSubHeaderWrapper)`
  height: 76px;
  min-width: 844px;
`;

export const PositionsAllocationSubHeaderTitle = styled.div<{ textAlignCenter?: boolean }>`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin: ${({ textAlignCenter }) => (textAlignCenter ? 'auto' : '0')};
`;

export const CheckboxText = styled.div`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-family: 'Poppins Medium';
  padding-left: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
`;

export const PositionsAllocationSubHeaderTableData = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 16px 24px;
  width: 100%;
  height: 72px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  background-color: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey4};
`;

export const PositionsAllocationTableContainer = styled.div`
  margin-bottom: 40px;
`;

export const PositionsAllocationTableBody = styled(BKJTableBody)`
  width: 100%;
`;

export const PositionsAllocationContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  width: 68%;
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  padding-bottom: 24px;
`;

export const PositionsAllocationTableWrapper = styled(BKJTableWrapper)`
  width: 100%;
  height: auto;
`;

export const PositionsAllocationTableRowWrapper = styled(BKJTableRowWrapper)<{ isGrey?: boolean }>`
  background-color: ${({ isGrey, theme }) => (isGrey ? theme.colors.Grey1 : 'white')};
`;

export const UnderlineButton = styled(BKJButton)`
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  background-color: transparent;
  border: none;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  padding: 0px;
  justify-content: start;
  margin-left: 5px;
`;
